var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.captionsList && _vm.captionsList.length > 1
    ? _c(
        "div",
        {
          staticClass: "caption-control",
          class: _vm.popupVisible ? "active" : "",
          on: {
            mouseleave: function($event) {
              _vm.popupVisible = false
            }
          }
        },
        [
          _c("VsButton", {
            staticClass: "p-0",
            attrs: {
              tracker: _vm.getAnalyticPayload(function(e) {
                return e.player["control-bar"].click.caption
              }),
              icon: "md:closed_caption"
            },
            nativeOn: {
              click: function($event) {
                _vm.popupVisible = !_vm.popupVisible
              }
            }
          }),
          _vm._v(" "),
          _vm.popupVisible
            ? _c(
                "div",
                { staticClass: "caption-control__window" },
                _vm._l(_vm.captionsList, function(track, index) {
                  return _c(
                    "div",
                    {
                      key: track.label,
                      staticClass: "caption-control__window__item",
                      class: index === _vm.currentCaptions ? "active" : "",
                      on: {
                        click: function($event) {
                          return _vm.$_changeCaption({
                            track: track,
                            index: index
                          })
                        }
                      }
                    },
                    [_vm._v("\n      " + _vm._s(track.label) + "\n    ")]
                  )
                }),
                0
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }